var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmWorkOrders = function SvgBmWorkOrders(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.6,10.2H8A.6.6,0,0,0,8,9H5.6a.6.6,0,1,0,0,1.2Z",
    transform: "translate(-2 -3.6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.6,14.2h4.8a.6.6,0,1,0,0-1.2H5.6a.6.6,0,1,0,0,1.2Z",
    transform: "translate(-2 -5.2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.48,29.988H11.5l-.012-.018Z",
    transform: "translate(-4.592 -11.988)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.8,11.6v7.8a.6.6,0,0,1-.6.6H.6a.6.6,0,0,1-.6-.6V5.6A.6.6,0,0,1,.6,5H8.532A5.616,5.616,0,0,0,8.4,6.2H1.2V18.8H12.6V11.468a5.616,5.616,0,0,0,1.2.132Z",
    transform: "translate(0 -2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.2,0a4.2,4.2,0,1,0,4.2,4.2A4.2,4.2,0,0,0,20.2,0Zm2.136,4.62H20.62V6.336a.42.42,0,0,1-.84,0V4.62H18.064a.42.42,0,1,1,0-.84H19.78V2.064a.42.42,0,0,1,.84,0V3.78h1.716a.42.42,0,1,1,0,.84Z",
    transform: "translate(-6.4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.2,21.8H5.6a.6.6,0,0,1-.6-.6V17.6a.6.6,0,0,1,.6-.6h6.6a.6.6,0,0,1,.6.6v3.6A.6.6,0,0,1,12.2,21.8Zm-6-1.2h5.4V18.2H6.2Z",
    transform: "translate(-2 -6.8)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmWorkOrders, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_WorkOrders.7cbcf18d.svg";
export { ForwardRef as ReactComponent };